// Returns a small badge descriptor { text, color, bg, blink } for a closing card,
// based on its current closing_step and the relevant date column. Null if nothing to show.
//
// opts.withStep = true → prefix the sub-step name, e.g. "Facturation (2j)".
//   Used in the main /projects kanban where all closing cards share one column.
// opts.withStep = false (default) → short form, e.g. "Depuis 2j".
//   Used in /projects/closing where the column already names the step.
const STEP_SHORT = {
  livrables: 'Livrables',
  reception: 'Réception',
  facturation: 'Facturation',
  attente_paiement: 'Att. paiement',
  encaisse: 'Encaissé',
};

export function closingDateBadge(item, opts = {}) {
  const withStep = !!opts.withStep;
  const cs = item?.closing_step;
  if (!cs) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const daysSince = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    d.setHours(0, 0, 0, 0);
    return Math.floor((today - d) / 86400000);
  };

  if (cs === 'livrables') {
    if (!item.livrables_deadline) return null;
    const d = new Date(item.livrables_deadline);
    d.setHours(0, 0, 0, 0);
    const left = Math.round((d - today) / 86400000);

    let metric, longText;
    if (left < 0) { metric = `Retard ${-left}j`; longText = `En retard de ${-left}j`; }
    else if (left === 0) { metric = 'Auj.'; longText = "Échéance aujourd'hui"; }
    else { metric = `J-${left}`; longText = `J-${left}`; }

    const text = withStep ? `${STEP_SHORT.livrables} (${metric})` : longText;
    const urgent = left <= 10; // ≤10 days (incl. today & overdue) → red + blink
    return urgent
      ? { text, color: '#dc2626', bg: '#fef2f2', blink: true }
      : { text, color: '#d97706', bg: '#fffbeb' };
  }

  if (['reception', 'facturation', 'attente_paiement'].includes(cs)) {
    const col = { reception: 'reception_date', facturation: 'facturation_date', attente_paiement: 'attente_paiement_date' }[cs];
    const n = daysSince(item[col]);
    if (n === null) return null;
    const text = withStep ? `${STEP_SHORT[cs]} (${n}j)` : (n === 0 ? 'Auj.' : `Depuis ${n}j`);
    return { text, color: '#616161', bg: '#f0f0f0' };
  }

  if (cs === 'encaisse') {
    if (!item.payment_date) return null;
    const d = new Date(item.payment_date);
    const text = withStep
      ? `Encaissé (${d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })})`
      : `Payé le ${d.toLocaleDateString('fr-FR')}`;
    return { text, color: '#059669', bg: '#f0fdf4' };
  }

  return null;
}
